module.exports = __webpack_public_path__ + "src/assets/sounds/sand_start_sound.mp3";